import { useTranslation } from "react-i18next"
import Oops from "./Oops/Oops"
import { GraphQLError } from "graphql/error/GraphQLError"
import { ApolloError } from "@apollo/client/errors"
import GetEnvironment from "../environments"
import { useRecoilValue } from "recoil"
import { signedInUserState } from "./StateSelectors"
import { GraphQLFormattedError } from "graphql"

export const OopsLocalError = (props: { heading?: string; error: ApolloError }) => {
  const email = useRecoilValue(signedInUserState)
  const { t } = useTranslation("common")

  const gqlError = props.error.graphQLErrors[0]
  const requestId = gqlError?.extensions?.requestId

  if (gqlError) {
    const code = gqlError.extensions?.code
    if (nonGenericErrors[code]) {
      return (
        <Oops
          body={getLocalCodeMessage(t, gqlError, email)}
          heading={getLocalCodeHeading(t, gqlError)}
          requestId={requestId}
        />
      )
    }
  }

  if (GetEnvironment().hideRawErrorMessages) {
    return <Oops body={getLocalGenericMessage(t, gqlError)} heading={props.heading} requestId={requestId} />
  } else {
    return <Oops body={getLocalRawMessage(props.error)} heading={props.heading} requestId={requestId} />
  }
}

const getLocalCodeHeading = (t: any, gqlError: GraphQLFormattedError<Record<string, any>>) =>
  t(`error.heading.${gqlError.extensions?.code}`)

const getLocalCodeMessage = (t: any, gqlError: GraphQLFormattedError<Record<string, any>>, email?: string) =>
  t(`error.${gqlError.extensions?.code}`, { email })

const getLocalGenericMessage = (t: any, gqlError: GraphQLFormattedError<Record<string, any>>) => t("error.generic")

const getLocalRawMessage = (apolloError: ApolloError) => apolloError.message

const nonGenericErrors: { [key: string]: true } = { NO_USER_ACCESS: true }
